import React from 'react';
import './App.css';
import Header from "./Containers/Header"
import {
    BrowserRouter,
    Switch,
    Route,
    Redirect
} from "react-router-dom"
import PersonalArea from "./Containers/PersonalArea";
import AllOrder from "./Containers/AllOrder";
import NotFound from "./Components/NotFoundPage";
import CartPage from "./Containers/CartPage";
import CatalogPage from "./Containers/CatalogPage";
import {OrderIDPage} from "./Containers/OrderIDPage";
import MakeOrder from "./Containers/MakeOrder";
import {Footer} from "./Components/Footer";

function App() {
  return (
    <div className="App">
        <BrowserRouter>
            <Header/>
            <Switch>
                <Route exact path={"/"} component={PersonalArea}/>
                <Route exact path={"/order"} component={AllOrder}/>
                <Route exact path={"/order/:id(\\d+)"} component={OrderIDPage}/>
                <Route exact path={"/cart"} component={CartPage}/>
                <Route exact path={"/catalog/:id(\\d+)"} component={CatalogPage}/>
                <Route exact path={"/catalog"} component={RedirectCatalog}/>
                <Route exact path={"/order_create"} component={MakeOrder}/>
                <Route component={NotFound}/>
            </Switch>
            <Footer />
        </BrowserRouter>
    </div>
  );
}

class RedirectCatalog extends React.Component{
    render(){
        return <Redirect to={'/catalog/1'} />;
    }
}

export default App;
